class TabbedMegamenuTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.tabs = Array.from(this.querySelectorAll('.tm-tab'));

    // Tab clicks must not reach the theme's document-level click handler,
    // which closes the navigation menus after any click inside them.
    this.addEventListener('click', (event) => {
      if (event.target.closest('.tm-tab')) event.stopPropagation();
    });

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.activate(next, true);
  }
}

if (!customElements.get('tabbed-megamenu-tabs')) {
  customElements.define('tabbed-megamenu-tabs', TabbedMegamenuTabs);
}
